import { variantSummary } from "./variant-quantities.mjs";
import { rupiah } from "@/lib/format";

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));

const methodLabel = { tunai: "Tunai", transfer: "Transfer", qris: "QRIS" };

// Cetak struk lewat jendela khusus (latar putih, 80mm) — tanpa ruang hitam/kosong, bisa auto-cetak.
export function printReceipt(tx, s = {}, cashier = "") {
  if (!tx) return;
  const date = new Date(tx.created_at);
  const dateStr = date.toLocaleString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const line = '<div class="hr"></div>';
  const row = (l, r, b) => `<div class="row${b ? " b" : ""}"><span>${l}</span><span>${r}</span></div>`;

  let items = "";
  tx.items.forEach((it) => {
    const lvl = (it.price_level || "").slice(0, 3).toUpperCase();
    items += `<div class="it"><div>${it.name}</div>` +
      `<div class="row"><span>${it.qty} x ${rupiah(it.price)}${lvl ? ` (${lvl})` : ""}</span><span>${rupiah(it.qty * it.price)}</span></div>`;
    if (variantSummary(it)) items += `<div class="it-variants">${escapeHtml(variantSummary(it))}</div>`;
    if (it.discount > 0) items += `<div class="row"><span>&nbsp;&nbsp;Diskon item</span><span>-${rupiah(it.discount)}</span></div>`;
    if (it.note) items += `<div class="it-note">&nbsp;&nbsp;* ${it.note}</div>`;
    items += `</div>`;
  });

  let pays = "";
  (tx.payments || []).forEach((p) => { pays += row(methodLabel[p.method] || p.method, rupiah(p.amount)); });

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Struk ${tx.invoice_no}</title>
    <style>
      @page { margin: 0; size: 80mm auto; }
      * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      html, body { margin: 0; padding: 0; background: #fff; color: #000; }
      #r { width: 72mm; margin: 0; padding: 2mm 3mm; font-family: 'Courier New', monospace; font-size: 12px; line-height: 1.25; }
      .c { text-align: center; }
      .b { font-weight: bold; }
      .big { font-size: 15px; font-weight: bold; }
      .sm { font-size: 10px; }
      .hr { border-top: 1px dashed #000; margin: 5px 0; }
      .row { display: flex; justify-content: space-between; gap: 8px; }
      .it { margin-bottom: 3px; }
      .it-note { font-style: italic; }
      .total { display:flex; justify-content:space-between; font-weight:bold; font-size:14px; margin-top:2px; }
    </style></head><body><div id="r">
      <div class="c big">${s.store_name || "POS KASIR SM"}</div>
      ${s.address ? `<div class="c sm">${s.address}</div>` : ""}
      ${s.phone ? `<div class="c sm">Telp ${s.phone}</div>` : ""}
      ${line}
      <div class="row"><span>No</span><span>${tx.invoice_no}</span></div>
      <div class="row"><span>${dateStr}</span></div>
      <div class="row"><span>Kasir: ${cashier || ""}</span></div>
      ${line}
      ${items}
      ${line}
      ${row("Jumlah Produk", tx.items.length)}
      ${row("Subtotal", rupiah(tx.subtotal))}
      ${tx.discount > 0 ? row("Diskon", "-" + rupiah(tx.discount)) : ""}
      <div class="total"><span>TOTAL</span><span>${rupiah(tx.total)}</span></div>
      ${line}
      ${pays}
      ${row("Bayar", rupiah(tx.paid))}
      ${row("Kembali", rupiah(tx.change))}
      ${tx.customer_name ? row("Pelanggan", tx.customer_name) : ""}
      ${tx.credit > 0 ? `<div class="total" style="font-size:12px"><span>SISA PIUTANG</span><span>${rupiah(tx.credit)}</span></div>` : ""}
      ${line}
      <div class="c sm" style="white-space:pre-line">${s.footer || "*** TERIMA KASIH ***"}</div>
    </div>
    <script>window.onload=function(){setTimeout(function(){window.focus();window.print();},150);};window.onafterprint=function(){window.close();};</script>
    </body></html>`;

  const w = window.open("", "_blank", "width=360,height=640");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
